module.exports = __webpack_public_path__ + "img/marker.c5dfe532.svg";